import { SharedCurrentUser } from "./types";

export const isVisitableUserProfile = (user: { is_profile_visitable: boolean }, currentUser: SharedCurrentUser) => {
  if (!currentUser?.is_all_public_feature_accessible) return false;

  return user.is_profile_visitable;
};
